var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show
    ? _c(
        "v-snackbar",
        {
          attrs: {
            id: "info-snackbar",
            color: _vm.error ? "error" : "success",
            elevation: "24",
            timeout: "10000",
            top: "",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "action",
                fn: function ({ attrs }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._b(
                        {
                          attrs: { id: "hide-snackbar", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.show = false
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      [_vm._v(" Close ")]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            1500658540
          ),
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [_vm._v(" " + _vm._s(_vm.message) + " ")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }